export default function FinishExamConfirmModal({ open, onCancel, onConfirm }) {
    if (!open) return null;

    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="finish-exam-title"
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 10000,
                display: 'grid',
                placeItems: 'center',
                padding: 16,
                background: 'rgba(15, 23, 42, 0.62)'
            }}
        >
            <div
                style={{
                    width: 'min(92vw, 440px)',
                    borderRadius: 12,
                    background: '#fff',
                    color: '#111827',
                    boxShadow: '0 24px 60px rgba(0,0,0,.28)',
                    padding: 20,
                    display: 'grid',
                    gap: 14
                }}
            >
                <div id="finish-exam-title" style={{ fontSize: 18, fontWeight: 800 }}>
                    Potwierdź zakończenie egzaminu
                </div>
                <div style={{ lineHeight: 1.5, color: '#374151' }}>
                    Czy na pewno chcesz zakończyć egzamin? Po potwierdzeniu nie będzie można wrócić do odpowiedzi.
                </div>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    <button
                        type="button"
                        onClick={onCancel}
                        style={{
                            border: '1px solid #d1d5db',
                            background: '#fff',
                            color: '#111827',
                            borderRadius: 8,
                            padding: '10px 14px',
                            fontWeight: 700,
                            cursor: 'pointer'
                        }}
                    >
                        Anuluj
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        style={{
                            border: 'none',
                            background: '#c00',
                            color: '#fff',
                            borderRadius: 8,
                            padding: '10px 14px',
                            fontWeight: 800,
                            cursor: 'pointer'
                        }}
                    >
                        Tak, zakończ egzamin
                    </button>
                </div>
            </div>
        </div>
    );
}
